const strings = {
  DEVICE_LOGS_TITLE: 'Device Logs',
  DEVICE_SERIAL_PLACEHOLDER: 'Device Serial',
  SEVERITY_FILTER_LABEL: 'Severity',
  ALL_SEVERITIES: 'All Severities',
  INFO: 'Info',
  WARNING: 'Warning',
  ERROR: 'Error',
  FROM_DATE_LABEL: 'From date',
  TO_DATE_LABEL: 'To date',
  APPLY: 'Apply',
  PREV: 'Prev',
  NEXT: 'Next',
  PAGE_LABEL: 'Page',
  LIMIT_LABEL: 'Limit',
  NO_DEVICES_FOUND: 'No devices found.',
  NO_ALERTS_FOUND: 'No active alerts found.',
  CLOSE: 'Close',
  FETCH_LOGS_ERROR: 'Failed to fetch logs',
};

export default strings;
